import { render, staticRenderFns } from "./mailYcelAddB2C.vue?vue&type=template&id=81ccb8c8"
import script from "./mailYcelAddB2C.vue?vue&type=script&lang=js"
export * from "./mailYcelAddB2C.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports